import { ALERT_COLORS } from './alertColors';
import { BACKGROUND_COLORS } from './backgroundColors';
import { BORDER_COLORS } from './borderColors';
import { PALETTE } from './palette/index';
import { TEXT_COLORS } from './textColors';

export const ALTO_COLORS = {
  BACKGROUND_COLORS,
  BORDER_COLORS,
  PALETTE,
  TEXT_COLORS,
  ALERT_COLORS,
} as const;
